import { MessageCircle, X } from 'lucide-react';

interface ChatFloatingButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  alertCount?: number;
}

export function ChatFloatingButton({ isOpen, onToggle, alertCount = 0 }: ChatFloatingButtonProps) {
  return (
    <button
      onClick={onToggle}
      title={isOpen ? 'Fermer l\'assistant stock' : 'Ouvrir l\'assistant stock'}
      className={`
        fixed bottom-6 right-6 z-50
        w-14 h-14 rounded-full shadow-lg
        flex items-center justify-center
        transition-all duration-200 ease-in-out
        ${isOpen
          ? 'bg-gray-700 hover:bg-gray-800 rotate-0'
          : 'bg-indigo-600 hover:bg-indigo-700 hover:scale-105'
        }
      `}
    >
      {isOpen ? (
        <X className="w-6 h-6 text-white" />
      ) : (
        <>
          <MessageCircle className="w-6 h-6 text-white" />
          {alertCount > 0 && (
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-50 dark:bg-red-900/200 text-white text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-white">
              {alertCount > 9 ? '9+' : alertCount}
            </span>
          )}
        </>
      )}
    </button>
  );
}
